import { useContext } from 'react';
import { Grid, Typography, Table, TableRow, TableHead, TableBody, TableCell, List, ListItem } from '@mui/material';
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';
import { ticketDetailsContext } from '../../TicketDetailsContext';
import { appUserContext } from 'helpers/services';
import { SimecUser } from 'components';

let TeamSummary = () => {
    let { formatMessage } = useIntl();

    let { isMobile } = useContext(appUserContext);
    let service = useContext(ticketDetailsContext);


    return (
        <Grid container>
            <Grid item xs={12} md={12}>
                {isMobile === false &&
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>{formatMessage({ id: LocalizationIds.Name })}</TableCell>
                                <TableCell align="right">{formatMessage({ id: LocalizationIds.ExpectedDays })}</TableCell>
                                <TableCell align="right">{formatMessage({ id: LocalizationIds.TotalWorkedDays })}</TableCell>
                                <TableCell align="right">{formatMessage({ id: LocalizationIds.TotalDays })}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {service.teamReview.map(review =>
                                <TableRow key={review.userName}>
                                    <TableCell>
                                        <SimecUser username={review.userName} />
                                    </TableCell>
                                    <TableCell align="right">{review.expectedDays}</TableCell>
                                    <TableCell align="right">{review.totalWorkedDays}</TableCell>
                                    <TableCell align="right">{review.totalDays}</TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                }
                {isMobile === true &&
                    <List>
                        {service.teamReview.map((review, index) =>
                            <ListItem disableGutters divider key={index}>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <Typography variant="body2">
                                            <b>{formatMessage({ id: LocalizationIds.Name })}:</b>&nbsp;
                                        </Typography>
                                        <SimecUser username={review.userName} />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Typography variant="body2">
                                            <b>{formatMessage({ id: LocalizationIds.ExpectedDays })}:</b>&nbsp;
                                        </Typography>
                                        {review.expectedDays}
                                    </Grid>

                                    <Grid item xs={12}>
                                        <Typography variant="body2">
                                            <b>{formatMessage({ id: LocalizationIds.TotalWorkedDays })}:</b>&nbsp;
                                        </Typography>
                                        {review.totalWorkedDays}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body2">
                                            <b>{formatMessage({ id: LocalizationIds.TotalDays })}:</b>&nbsp;
                                        </Typography>
                                        {review.totalDays}
                                    </Grid>
                                </Grid>
                            </ListItem>
                        )}
                    </List>
                }
            </Grid>
        </Grid>
    )
}

export default TeamSummary;